import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Space, Popconfirm, message, Typography } from "antd";
import { EditOutlined, SendOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { fetchPackingList, sendPackingEvent } from "./packingThunk";
import PackingEditDrawer from "./components/PackingEditDrawer";

const { Title } = Typography;

const STATUS_COLORS = {
    not_started: "default",
    pending: "blue",
    sent: "green",
    failed: "red",
};

const PackingRecord = () => {
    const dispatch = useDispatch();
    const { list, listLoading } = useSelector((s) => s.tatmeenPacking);

    const [sendingId, setSendingId] = useState(null);
    const [editingId, setEditingId] = useState(null);

    const loadList = () => dispatch(fetchPackingList());

    useEffect(() => {
        loadList();
    }, [dispatch]);

    const handleSend = async (id) => {
        setSendingId(id);
        try {
            const result = await dispatch(sendPackingEvent(id)).unwrap();
            message.success(result.message || "Packing event queued with Tatmeen");
            loadList();
            // Final status is recorded in the background ~5s after queuing
            setTimeout(loadList, 7000);
        } catch (err) {
            message.error(err || "Failed to send packing event");
            loadList();
        } finally {
            setSendingId(null);
        }
    };

    const columns = [
        { title: "SSCC Code", dataIndex: "sscc_code", key: "sscc_code" },
        { title: "Items", dataIndex: "item_count", key: "item_count" },
        {
            title: "Status",
            dataIndex: "tatmeen_sent_status",
            key: "tatmeen_sent_status",
            render: (status) => (
                <Tag color={STATUS_COLORS[status] || "default"}>
                    {(status || "not_started").replace("_", " ").toUpperCase()}
                </Tag>
            ),
        },
        // {
        //     title: "Created At",
        //     dataIndex: "created_at",
        //     key: "created_at",
        //     render: (value) => (value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "-"),
        // },
        {
            title: "Action",
            key: "action",
            render: (_, record) => {
                const isSent = ["sent", "pending"].includes(record.tatmeen_sent_status);
                return (
                    <Space>
                        <Button
                            icon={<EditOutlined />}
                            disabled={isSent}
                            onClick={() => setEditingId(record.id)}
                        >
                            Edit
                        </Button>
                        <Popconfirm
                            title="Send this packing to Tatmeen?"
                            description="This sends a live EPCIS commissioning event and cannot be undone."
                            onConfirm={() => handleSend(record.id)}
                            disabled={isSent}
                        >
                            <Button
                                type="primary"
                                icon={<SendOutlined />}
                                disabled={isSent}
                                loading={sendingId === record.id}
                            >
                                Send to Tatmeen
                            </Button>
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];

    return (
        <div style={{ padding: 20 }}>
            <Title level={3} style={{ margin: 0, marginBottom: 16 }}>
                Packing Record
            </Title>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={list}
                loading={listLoading}
                pagination={{ pageSize: 10 }}
            />

            <PackingEditDrawer
                open={!!editingId}
                packingId={editingId}
                onClose={() => setEditingId(null)}
                onUpdated={loadList}
            />
        </div>
    );
};

export default PackingRecord;
